// extracted by css-extract-rspack-plugin
export default {"wrapper":"_e527332b","dimensions":"_8e90f9b"};